import React, { useState } from 'react';
import {
  CheckCircleOutlined as CheckCircleOutlinedIcon,
  HighlightOffOutlined as HighlightOffOutlinedIcon,
  Info as InfoIcon,
  Launch as LaunchIcon,
  Close as CloseIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon
} from '@mui/icons-material';
import "../../../../styles/FakeNewsMain.css"
const FakeNewsModal = ({ isOpen, onClose, item, formatDate, truncateToWordLimit, placeholder }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handlePrevImage = () => {
    setCurrentImageIndex(prev => 
      prev === 0 ? item.imageLink.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex(prev => 
      prev === item.imageLink.length - 1 ? 0 : prev + 1
    );
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fn-modal-backdrop" onClick={handleBackdropClick}>
      <div className="fn-modal-container">
        <div className="fn-modal-header">
          <h2 className="fn-modal-title">Fake News Details</h2>
          <button className="fn-modal-close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="fn-modal-content">
          {/* Image Gallery */}
          {item.imageLink && item.imageLink.length > 0 && (
            <div className="fn-modal-image-section">
              <div className="fn-modal-image-wrapper">
                <img
                  src={item.imageLink[currentImageIndex] || placeholder}
                  alt="Fact Check Evidence"
                  className="fn-modal-image"
                  onError={(e) => {
                    e.target.src = placeholder;
                  }}
                />
                {item.imageLink.length > 1 && (
                  <>
                    <button 
                      className="fn-modal-nav-btn fn-modal-nav-prev" 
                      onClick={handlePrevImage}
                    >
                      <ChevronLeftIcon />
                    </button>
                    <button 
                      className="fn-modal-nav-btn fn-modal-nav-next" 
                      onClick={handleNextImage}
                    >
                      <ChevronRightIcon />
                    </button>
                  </>
                )}
              </div>
              {item.imageLink.length > 1 && (
                <div className="fn-modal-image-counter">
                  {currentImageIndex + 1} of {item.imageLink.length}
                </div>
              )}
            </div>
          )}

          {/* Claim Section */}
          <div className="fn-modal-section">
            <h3 className="fn-modal-section-title">Claim</h3>
            <div className="fn-modal-claim-text">{item.claim}</div>
          </div>

          {/* Verdict Section */}
          <div className="fn-modal-section">
            <div className={`fn-modal-verdict-badge ${
              item.final_verdict ? "fn-modal-verdict-true" : "fn-modal-verdict-false"
            }`}>
              {item.final_verdict ? (
                <CheckCircleOutlinedIcon style={{ fontSize: "24px" }} />
              ) : (
                <HighlightOffOutlinedIcon style={{ fontSize: "24px" }} />
              )}
              <strong>{item.final_verdict ? "VERIFIED" : "FALSE"}</strong>
            </div>
          </div>

          {/* Fact Analysis */}
          {item.fact && (
            <div className="fn-modal-section">
              <div className="fn-modal-fact-header">
                <InfoIcon style={{ fontSize: "20px" }} />
                <h3 className="fn-modal-section-title">Fact Analysis</h3>
              </div>
              <div className="fn-modal-fact-text">{item.fact}</div>
            </div>
          )}

          {/* Metadata */}
          <div className="fn-modal-section">
            <h3 className="fn-modal-section-title">Details</h3>
            <div className="fn-modal-meta-grid">
              <div className="fn-modal-meta-item">
                <strong>Date:</strong> {formatDate(item.dateTime)}
              </div>
              <div className="fn-modal-meta-item">
                <strong>ID:</strong> {item._id ? item._id.slice(-8) : "N/A"}
              </div>
              <div className="fn-modal-meta-item">
                <strong>Full ID:</strong> {item._id || "N/A"}
              </div>
            </div>
          </div>

          {/* Sources */}
          {item.sources && item.sources.length > 0 && (
            <div className="fn-modal-section">
              <h3 className="fn-modal-section-title">Sources ({item.sources.length})</h3>
              <div className="fn-modal-sources-list">
                {item.sources.map((source, sourceIndex) => (
                  <div key={sourceIndex} className="fn-modal-source-item">
                    <a
                      href={source.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="fn-modal-source-link"
                    >
                      {source.title}
                      <LaunchIcon style={{ fontSize: "16px" }} />
                    </a>
                    <div className="fn-modal-source-snippet">
                      {source.snippet}
                    </div>
                    {source.published_date && (
                      <div className="fn-modal-source-date">
                        Published: {formatDate(source.published_date)}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Social Links */}
          {item.social_links && item.social_links.length > 0 && (
            <div className="fn-modal-section">
              <h3 className="fn-modal-section-title">Related Social Media ({item.social_links.length})</h3>
              <div className="fn-modal-social-list">
                {item.social_links.map((social, socialIndex) => (
                  <div key={socialIndex} className="fn-modal-social-item">
                    <a
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="fn-modal-social-link"
                    >
                      {social.title || "Social Post"}
                      <LaunchIcon style={{ fontSize: "16px" }} />
                    </a>
                    {social.snippet && (
                      <div className="fn-modal-social-snippet">
                        {social.snippet}
                      </div>
                    )}
                    {social.published_date && (
                      <div className="fn-modal-social-date">
                        Published: {formatDate(social.published_date)}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>


    </div>
  );
};


export default FakeNewsModal;